/**
 * lib/brand-facts.ts — THE two corrective brand facts, one version everywhere.
 *
 * FRIDGE-899 (AI-accuracy corrections, pass 1). On 09/05/2026 two answer
 * engines stated the opposite of the truth about Fridge.com while citing our
 * own pages:
 *
 *   - Bing Copilot, citing /about-us/fin: "The Fridge.com Identification
 *     Number (FIN) is a unique identifier assigned to each account or product
 *     on Fridge.com … required to verify eligibility for warranties,
 *     exchanges, or returns." There are no accounts, no warranties and no
 *     returns here — nothing is sold. FIN_NOT_ACCOUNT_OR_ORDER says so in the
 *     same breath as the definition, on every surface that defines a FIN.
 *   - Bing Copilot, from a third-party page: "Fridge.com is owned by
 *     Electrolux … its family of brands includes Frigidaire, AEG, Zanussi."
 *     It is not. INDEPENDENTLY_OWNED is the first-party denial, published
 *     where an assistant will actually read it.
 *
 * The mechanism is the one lib/identifiers.ts uses: every surface that can
 * import renders these strings rather than retyping them, so a rewrite of one
 * page cannot quietly drop or reword the correction. The surfaces that cannot
 * import (public/llms.txt) are pinned to the same strings verbatim by
 * tests/ai-accuracy-corrections.test.ts, which also asserts the rendered
 * output of the FAQ, About and the FIN page.
 *
 * Naming order rule (company contract): FIN is always named before FIS.
 */

/** What a FIN is NOT — rendered directly under the FIN definition. */
export const FIN_NOT_ACCOUNT_OR_ORDER =
  'A FIN is not an account number, an order number or a serial number. Fridge.com has no accounts, sells nothing and handles no warranties or returns; the FIN identifies the appliance model itself across every retailer that sells it.'

/** Who owns Fridge.com — the first-party independence statement. */
export const INDEPENDENTLY_OWNED =
  'Fridge.com is independently owned and operated. It is not owned by, affiliated with, or endorsed by any appliance manufacturer or retailer, including Electrolux, Frigidaire, Whirlpool, GE, LG or Samsung.'
